import * as React from 'react';
import Modal from 'components/Modal';
import "selfie/styles.scss";
import { imageBaseUrl } from 'config';
import { IReduxState } from 'reducers';
import { connect } from 'react-redux';

interface IProps {
    onSubmit: any;
    heading?: string;
    uploaded?: boolean;
    errorMsg?: string;
}

interface IState {
    showModal: boolean;
    photoSrc: string;
    stream: MediaStream;
    constraints: any;
    deniedPermission: boolean;
}

interface IConnectProps {
    utm_source?: string;
}

class SelfieCapture extends React.PureComponent<(IConnectProps & IProps),IState> {

    state = {
        showModal : false ,
        photoSrc: null,
        stream: null,
        constraints: {
            audio: false,
            video: { width: 500, height: 250 },
            facingMode: true ? 'user' : 'environment',
        },
        deniedPermission: false,
      }


    initializeCamera = () => {

        const navigator = (window as any).navigator
        navigator.getUserMedia =    navigator.mediaDevices.getUserMedia ||
                                    navigator.webkitGetUserMedia ||
                                    navigator.mozGetUserMedia ||
                                    navigator.msGetUserMedia;

        navigator.mediaDevices.getUserMedia(this.state.constraints)
          .then((stream: MediaStream) => {
            this.setState(
                {
                    stream: stream,
                    deniedPermission: false,
                },
                this.startCamera
            )
          })
          .catch((err) => {
            if (err?.message === "Permission denied") {
                this.setState({deniedPermission: true});
            }
            console.log(err);
          });

    }

    startCamera = () => {
        const video = this.refs.video as HTMLVideoElement;
        video.srcObject = this.state.stream;
        video.play()
    }

    savePicture = () => {
        const { photoSrc } = this.state;
        const b64Content = photoSrc.slice(22)
        this.props.onSubmit(b64Content);
        this.setState({showModal: false, photoSrc: null});
        this.state.stream.getTracks().forEach((track) => track.stop());
    }

    clearPhoto = () => {
        this.setState(
            {
                photoSrc: null
            },
            this.startCamera
            )
    }

    takePicture = () => {
        const canvas = this.refs.canvas as HTMLCanvasElement
        const video = this.refs.video as HTMLVideoElement

        const context = canvas.getContext('2d')

        canvas.width  = video.videoWidth;
        canvas.height = video.videoHeight;

      
        context.drawImage(video, 0, 0);

        const data = canvas.toDataURL('image/png');
        this.setState({photoSrc: data});
    }

    cancelModal = () => {
        this.setState({showModal: false, photoSrc: null});
        this.state.stream && this.state.stream.getTracks().forEach((track) => {
            track.stop();
          });
    }

    renderCamera = () => {
        return (
        <div className='camera'>
            <video id='video' ref='video' style={{width:'100%',maxHeight:'375px'}}></video>
            <div className="buttonHousing">
                <div onClick={ this.takePicture }>
                    <svg viewBox="0 0 10 10" width="50px">
                        <circle cx="5" cy="5" r="4" strokeWidth=".8" stroke="#f5821f" fill="#fff"></circle>
                        <circle cx="5" cy="5" r="3.2" fill="#f5821f"></circle>
                    </svg>
                </div>
            </div>
        </div>
        )
    }

    renderPhoto = () => {
            return (
            <div>
                <div className='output'>
                    <img
                        id= 'photo'
                        alt= 'Your Selfie'
                        ref= 'photo'
                        src= { this.state.photoSrc }
                        style= {{maxWidth:'100%', maxHeight:'375px'}}

                    />
                </div>
                <div className="buttonHousing" style={{justifyContent: "space-between"}}>
                 <div onClick={ this.clearPhoto } className= "buttonParent" >
                         <i className="fa fa-repeat" style={{fontSize: "20px" , marginRight: "4px" , color: "#8b8b8b"}}></i>
                         Retake
                 </div>
                     <div onClick={ this.savePicture } style={{color: "#f5821f"}} className= "buttonParent">
                         <i className="fa fa-check" style={{fontSize: "20px" , marginRight: "4px" , color: "#f5821f" }}></i>
                         Submit
                     </div>
                </div>
            </div>
            );
        }

    popCamera = () => {
        this.initializeCamera();
        this.setState({showModal: true});
    }

    render() {
        return (
            <div>
                <Modal
                   title = ' '
                   active = {this.state.showModal}
                   cancellable = {true}
                   onClose = {this.cancelModal}
                   disableFooter={true}
                >
                    {this.state.deniedPermission ? <div className="permission-warning">
                        <div>Please enable camera permission</div>
                        <div className="gif-container">
                            <img
                              src={`${imageBaseUrl}/img/camera-permissions.gif`}
                              alt="permission-denied"
                              height="220px"
                              width="auto"
                            />
                        </div>
                    </div> :
                        <>
                            <div className="capture">
                            {
                                !this.state.photoSrc?
                                    this.renderCamera()
                                    :this.renderPhoto()
                            }
                            </div>
                            <canvas
                                id = "canvas"
                                ref= "canvas"
                                hidden
                            ></canvas>
                        </>
                    }
                </Modal>
                <div onClick={this.popCamera} className={`selfie-capture-container ${this.props.utm_source}-background`}>
                    <div className="heading">
                        <span>{this.props.heading || "Selfie Capture"}</span>
                        {
                            this.props.uploaded &&
                            <div className="icon">
                                <img src={`${imageBaseUrl}/img/icons/green_tick.png`} alt="upload" />
                            </div>
                        }
                    </div>
                    <div className="col-md-1 col-sm-1" style={{padding: "0px 25px 8px 25px"}}>
                        <i className="fa fa-camera" style={{fontSize: "18px", color: "#F5821F"}}></i>
                    </div>
                </div>
                {this.props.errorMsg && <p className="inline-error-msg">{this.props.errorMsg}</p>}
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        utm_source: state.login.authExt ? state.login.authExt.utm_source : null,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(SelfieCapture);